import { render, staticRenderFns } from "./ExpenditureAdd.vue?vue&type=template&id=2fc27b74&scoped=true&"
import script from "./ExpenditureAdd.vue?vue&type=script&lang=js&"
export * from "./ExpenditureAdd.vue?vue&type=script&lang=js&"
import style0 from "./ExpenditureAdd.vue?vue&type=style&index=0&id=2fc27b74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc27b74",
  null
  
)

export default component.exports